import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { animate, style, transition, trigger } from '@angular/animations';

export const slideInFromLeft = trigger('slideInFromLeft', [
  transition(':enter', [
    style({ transform: 'translateX(-100%)', opacity: 0 }),
    animate('300ms ease-out', style({ transform: 'translateX(0)', opacity: 1 }))
  ]),
  transition(':leave', [
    animate('200ms ease-in', style({ transform: 'translateX(-100%)', opacity: 0 }))
  ])
]);

export const slideInFromRight = trigger('slideInFromRight', [
  transition(':enter', [
    style({ transform: 'translateX(100%)', opacity: 0 }),
    animate('300ms ease-out', style({ transform: 'translateX(0)', opacity: 1 }))
  ]),
  transition(':leave', [
    animate('200ms ease-in', style({ transform: 'translateX(100%)', opacity: 0 }))
  ])
]);

@Component({
    selector: 'lib-sys-notify',
    imports: [CommonModule],
    templateUrl: './sysNotify.component.html',
    styleUrl: './sysNotify.component.scss',
    animations: [slideInFromLeft, slideInFromRight]
})
export class SysNotifyComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any,  private snackBarRef: MatSnackBarRef<SysNotifyComponent>) { }
  
  close() {
    this.snackBarRef.dismiss();
  }
}




